module.exports = __webpack_public_path__ + "img/WebFirewall.062cf8e.svg";